// sagas.js

import { call, put, takeEvery } from "redux-saga/effects";
import { fetchJobsSuccess, fetchJobsFailure } from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
import { FETCH_JOBS_REQUEST } from "../../actionTypes";

function* fetchJobsSaga(action) {
  console.log("gggg", action.payload);
  try {
    const response = yield call(() =>
      AxiosInstance().post(
        `/job_search?page=${action.payload.page}&per_page=${action.payload.per_page}`,
        action.payload.data
      )
    );
    if (response.data.status == true) {
      yield put(fetchJobsSuccess(response.data));
    } else {
      yield put(fetchJobsFailure(response.data));
    }
  } catch (error) {
    yield put(fetchJobsFailure({ status: false, message: error.message }));
  }
}

function* jobSearchSaga() {
  yield takeEvery(FETCH_JOBS_REQUEST, fetchJobsSaga);
}

export default jobSearchSaga;
